// src/theme/context/ThemeProvider.tsx

import { useState, useEffect } from 'react';
import { colors } from '@/constants/colors';
import { ThemeContext, type Theme } from './ThemeContext';
import { StorageService } from '@/lib/StorageService';

const storageService = new StorageService();

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [theme, setThemeState] = useState<Theme>('light');

  useEffect(() => {
    const saved = storageService.getTheme() as Theme | null;
    if (saved) setThemeState(saved);
  }, []);

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  const setTheme = (newTheme: Theme) => {
    setThemeState(newTheme);
    storageService.setTheme(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, colors: colors[theme] }}>
      {children}
    </ThemeContext.Provider>
  );
};
